/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { SerializedLegacyFilter } from 'cio/types/conditions/legacy-filter';
import CampaignModel from 'cio/models/campaign';
import { computed } from '@ember/object';
import { ConditionViewerBackgroundVariant } from 'cio/utils/condition-viewer';
import { DataSourceLabelVariant } from 'cio/utils/data-source-label';

interface CioConditionLabelItemArgs {
  condition: SerializedLegacyFilter;
  campaign?: CampaignModel;
  size?: string;
  labelVariant?: DataSourceLabelVariant;
  labelTruncate?: boolean;
  tagName?: string;
  backgroundVariant?: ConditionViewerBackgroundVariant;
  allowForeignEvent?: boolean;
  containerClasses?: string;
}

export default class CioConditionLabelItem extends Component<CioConditionLabelItemArgs> {
  get tagName() {
    return this.args.tagName ?? 'div';
  }

  @computed('args.condition.{type,event.type}')
  get conditionType() {
    let conditionType = this.args.condition.type;

    // Event conditions, when serialized, will say "type: message", which the
    // backend then translates to bitmaps that are used for action and event
    // conditions alike. However, in the UI we need this to say "event", since
    // the editor for that type of condition is different from an "action"
    // condition editor.
    if (
      conditionType === 'message' &&
      'event' in this.args.condition &&
      typeof this.args.condition.event === 'object' &&
      ['foreign_event', 'event'].includes(this.args.condition.event.type)
    ) {
      conditionType = 'event';
    }

    if (conditionType === 'foreign_event') {
      conditionType = 'event';
    }

    return conditionType;
  }

  get backgroundVariant() {
    return this.args.backgroundVariant ?? ConditionViewerBackgroundVariant.Dark;
  }
}
